import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// Actions the server's sessions propose to the operator (ADR-039 step 2)

export function useActions(serverId: string) {
  const api = useApiClient();
  return useQuery({
    queryKey: ['actions', serverId],
    queryFn: () => api.outbox.actions(serverId),
    select: (d) => d.actions,
    refetchInterval: 60_000,
  });
}

export function useDecideAction(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { id: string; decision: 'approve' | 'reject' }) => api.outbox.decideAction(serverId, v.id, v.decision),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['actions', serverId] });
      void qc.invalidateQueries({ queryKey: ['inbox', serverId] });
      void qc.invalidateQueries({ queryKey: ['reviews', serverId] });
      void qc.invalidateQueries({ queryKey: ['deployments', serverId] });
    },
  });
}
